<script>
  import SidebarNav from '@/components/Sidebar/Nav';

  export default {
    components: {
      SidebarNav,
    },

    computed: {
      links () {
        return this.$route.matched.find(({ meta }) => typeof meta.links !== 'undefined').meta.links;
      },
    },
  };
</script>

<template>
  <div class="sidebar container container--padding">
    <div class="row">
      <!-- @todo if we need to swipe this component, we can use a named view -->
      <SidebarNav
        :links="links"
        />

      <RouterView class="col--10 card card__body" />
    </div>
  </div>
</template>

<style lang="scss">
  .sidebar {
    &__title {
      color: #FFF;
      font-size: 32px;
      font-weight: 300;
      margin-bottom: 32px;
      letter-spacing: .64px;
    }

    &__header {
      display: flex;
      margin-bottom: 64px;

      > :not(:last-child) {
        margin-right: 16px;
      }
    }
  }
</style>
